import React, { useCallback } from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { DropdownItem } from '@atlaskit/dropdown-menu-12';

import { toggleDiffComments } from 'src/redux/pull-request/actions';
import { publishUiEvent } from 'src/utils/analytics/publish';

import { useHiddenComments } from '../../../hooks/diffs';
import messages from '../../diff.i18n';

type Props = {
  filepath: string;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const ToggleCommentsItem: React.FC<Props> = React.memo(
  ({ filepath }) => {
    const dispatch = useDispatch();

    const onToggleComments = useCallback(() => {
      dispatch(toggleDiffComments(filepath));
      publishUiEvent({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'hideDiffCommentsButton',
        source: 'pullRequestScreen',
      });
    }, [filepath, dispatch]);

    const areCommentsHidden = useHiddenComments(filepath);

    return (
      <DropdownItem
        data-qa="pr-diff-file-comments"
        key="file-actions-menu-comments"
        onClick={onToggleComments}
      >
        {areCommentsHidden ? (
          <>
            <FormattedMessage {...messages.showComments} />
          </>
        ) : (
          <>
            <FormattedMessage {...messages.hideComments} />
          </>
        )}
      </DropdownItem>
    );
  }
);
